import { Component } from '@angular/core'
import { IonRouterOutlet } from '@ionic/angular/standalone'

@Component({
  selector: 'app-layout-session',
  templateUrl: './layout-session.component.html',
  styleUrls: ['./layout-session.component.css'],
  imports: [IonRouterOutlet],
})
export class LayoutSessionComponent {}
